import React from 'react'

import { useState } from "react"
import {
  Users,
  Rocket,
  MessageCircle,
  Calendar,
  X,
  User,
  Phone,
  Mail,
  Building2,
  ArrowRight,
  Star,
  Briefcase,
  IndianRupee,
} from "lucide-react"
import toast from 'react-hot-toast'
import { initializePayment } from '../utils/paymentUtils'
import { PaymentType } from '../utils/paymentTypes'
import PaymentModal from './CashfreePaymentModal'
import { Link } from 'react-router-dom'
const StartUpIdeas = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    startupName: "",
    programType: "startup-idea"
  })
  const [isSubmitting, setIsSubmitting] = useState(false)

  const [processing, setProcessing] = useState(false);
  const [paymentSessionId, setPaymentSessionId] = useState(null);
  const [currentOrderId, setCurrentOrderId] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);

    try {
      // 1. Validate inputs
      if (!formData.name || !formData.phone || !formData.email) {
        toast.error("Please fill all required fields");
        setProcessing(false);
        return;
      }

      // 2. Store registration temp data (same as events)
      sessionStorage.setItem(
        "startup_session_booking",
        JSON.stringify({
          ...formData,
          amount: 2000,

        })
      );

      const token = localStorage.getItem("Startuptoken");

      // 3. Initialize Payment (same function your events use)
      const payment = await initializePayment({
        type: PaymentType.STARTUP_IDEAS,  // reuse event payment logic
        amount: 2000,
        token,
        returnUrl: `${window.location.origin}/payment-callback`,
      });

      // 4. Extract session + order id and show modal
      setPaymentSessionId(payment?.payment_session_id);
      setCurrentOrderId(payment?.order_id);
      setShowPaymentModal(true);

    } catch (error) {
      console.error("Payment error:", error);
      toast.error(error.message || "Payment failed");
    } finally {
      setProcessing(false);
    }
  };


  const benefits = [
    { icon: Users, text: "1-on-1 Mentor Sessions" },
    { icon: MessageCircle, text: "Personalized Guidance" },
    { icon: Briefcase, text: "Industry Expert Insights" },
  ]

  const mentors = [
    { name: "Manoth Singh", role: "Founder of Tactos", rating: 5 },
    { name: "Hari", role: "CEO of Tactos", rating: 5 },
  ]
  return (
    <>
      {/* Horizontal Hero Section */}
      <section className="container mx-auto px-4 sm:px-6 py-8">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Left - Content */}
          <div className="flex-1 text-center lg:text-left">
            

            <h1 className="text-[20px] md:text-5xl lg:text-4xl font-bold text-gray-800 mb-3 leading-tight text-balance">
              TACTOS  
              <span className="text-[#fd3e3d]"> Idea Engine </span>
            </h1>

            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#fd3e3d]/10 text-[#fd3e3d] text-sm font-medium mb-4">
              <Users className="w-4 h-4" />
              
              <span>Get our Idea - Build your Startup</span>
            </div>

            <p className="text-black/70 text-sm md:text-md mb-8 max-w-xl mx-auto lg:mx-0 text-pretty">
              Aspiring Entrepreneur not knowing what to build?
              Get Actionable business ideas solving real world
              problems.
              A curated library of high-potential startup ideas ready
              to build and scale.
              Each concept includes problem clarity, business
              models, strategy, and execution steps.
              Founders start with validated, structured ideas -
              eliminating guesswork and risk.

            </p>

            {/* Benefits - Updated to black/red theme */}
            <div className="flex flex-wrap gap-4 justify-center lg:justify-start mb-3">
              {benefits.map((benefit, idx) => (
                <div key={idx} className="flex items-center gap-2 px-4 py-2 rounded-lg bg-black text-white">
                  <benefit.icon className="w-4 h-4 text-[#fd3e3d]" />
                  <span className="text-sm font-medium">{benefit.text}</span>
                </div>
              ))}
            </div>

            {/* Pricing Section */}
            <div className="flex flex-col sm:flex-row items-center gap-4 mb-8 justify-center lg:justify-start">


              {/* CTA - Updated to red button */}
              <Link
                to={'/instructions/startuppage'}

                className="group inline-flex items-center gap-3 bg-[#fd3e3d] hover:bg-[#e63635] text-white font-semibold py-4 px-8 rounded-xl transition-all duration-300 shadow-lg shadow-[#fd3e3d]/25 hover:shadow-[#fd3e3d]/40 h-[47px]"
              >
                Apply now
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>




          </div>

          {/* Right - Mentor Cards */}
          <div className="flex-1 w-full max-w-md lg:max-w-lg hidden lg:block">
            <div className="space-y-4">
              {mentors.map((mentor, idx) => (
                <div
                  key={idx}
                  className="flex items-center gap-4 p-4 rounded-2xl bg-white border border-black/10 shadow-sm hover:shadow-md transition-shadow"
                >
                  <div className="w-14 h-12 rounded-full bg-black flex items-center justify-center text-white font-bold text-lg">
                    {mentor.name
                      .split(" ")
                      .map((n) => n[0])
                      .join("")}
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-black">{mentor.name}</h3>
                    <p className="text-black/50 text-sm">{mentor.role}</p>
                  </div>
                  <div className="flex items-center gap-1">
                    {Array.from({ length: mentor.rating }).map((_, i) => (
                      <Star key={i} className="w-4 h-4 fill-[#fd3e3d] text-[#fd3e3d]" />
                    ))}
                  </div>
                </div>
              ))}

              {/* Stats Card - Updated to black background */}
              <div className="p-4 rounded-2xl bg-black text-white">
                <div className="grid grid-cols-3 gap-4 text-center">
                  <div>
                    <div className="text-2xl font-bold">150+</div>
                    <div className="text-white/60 text-xs">Mentors</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-[#fd3e3d]">100+</div>
                    <div className="text-white/60 text-xs">Ideas Shared</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold">100%</div>
                    <div className="text-white/60 text-xs">Satisfaction</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal Form */}

    </>
  )
}

export default StartUpIdeas
